import { render, staticRenderFns } from "./salePerson.vue?vue&type=template&id=f92e2446&scoped=true&"
import script from "./salePerson.vue?vue&type=script&lang=js&"
export * from "./salePerson.vue?vue&type=script&lang=js&"
import style0 from "./salePerson.vue?vue&type=style&index=0&id=f92e2446&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f92e2446",
  null
  
)

export default component.exports